export default __webpack_public_path__ + "static/media/arrow-up.20e04ca6.png";